import AdminOnlineUsersHome from "@/components/admin/AdminOnlineUsersHome.vue";
import AdminPlatformContractsHome from "@/components/admin/AdminPlatformContractsHome.vue";
import AdminRegistrationFunnelHome from "@/components/admin/AdminRegistrationFunnelHome.vue";
import AdminWorkflowDetailsPage from "@/components/admin/AdminWorkflowDetailsPage.vue";
import AdminWorkflowsHome from "@/components/admin/AdminWorkflowsHome.vue";
import PlatformEmailSettings from "@/components/admin/PlatformEmailSettings.vue";

const literalAdminMeta = Object.freeze({
  requiresAuth: true,
  requiresCompanyContext: false,
  literalRoles: ["admin"],
});

export default [
  { path: "/admin", redirect: "/admin/contracts" },
  {
    path: "/admin/contracts",
    name: "AdminPlatformContracts",
    component: AdminPlatformContractsHome,
    meta: literalAdminMeta,
  },
  {
    path: "/admin/analytics",
    name: "AdminRegistrationFunnel",
    component: AdminRegistrationFunnelHome,
    meta: literalAdminMeta,
  },
  {
    path: "/admin/workflows",
    name: "AdminWorkflowsHome",
    component: AdminWorkflowsHome,
    meta: literalAdminMeta,
  },
  {
    path: "/admin/workflows/:workflowKey",
    name: "AdminWorkflowDetails",
    component: AdminWorkflowDetailsPage,
    props: true,
    meta: literalAdminMeta,
  },
  {
    path: "/admin/online-users",
    name: "AdminOnlineUsers",
    component: AdminOnlineUsersHome,
    meta: literalAdminMeta,
  },
  {
    path: "/admin/platform-email",
    name: "PlatformEmailSettings",
    component: PlatformEmailSettings,
    meta: literalAdminMeta,
  },
];
